// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-row {
  display: grid;
  align-items: center;
}
.dialog-row__setting > * {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/components/DialogRow/DialogRow.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;AACJ;AACI;EACI,eAAA;AACR","sourcesContent":[".dialog-row {\n  display: grid;\n  align-items: center;\n}\n.dialog-row__setting > * {\n  max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
